export function toImageSet(images = [], setLength = 2) {
  return images.reduce((sets, image) => {
    const currIndex = sets.length - 1
    let currSet = { index: sets.length, set: [] }
    if (
      // initially
      currIndex === -1
      // or in case we reached the set length limit
      || sets[currIndex].set.length === setLength
    ) {
      // create a new set entry
      sets.push(currSet)
    }
    else {
      currSet = sets[currIndex]
    }

    currSet.set.push(image)
    return sets
  }, [])
}

export function imagesByType(images = []) {
  const result = images.reduce((all, image) => {
    if (image && image.pivot && image.pivot.type === 'banner' && !all.bannerImage) {
      all.bannerImage = image
    }
    else {
      all.otherImages.push(image)
    }
    return all
  }, { bannerImage: null, otherImages: [] })

  if (!result.bannerImage && result.otherImages.length) {
    result.bannerImage = result.otherImages.shift()
  }

  return result
}



// WEBPACK FOOTER //
// ./src/shared/utils/images.js